var option_webview_default = {
  "option": "Gg8Z-",
  "user_choice": "_6KwbN",
  "check": "jjrBv",
  "image": "-b-4-",
  "input": "dS8Y1",
  "title": "IrEYz",
  "centered": "Yh0n8",
  "with_result": "_8Bk1d",
  "list": "T-RcP",
  "with_image": "e9-vK",
  "progress": "zcgqv",
  "progress_value": "KCwJp",
  "label": "V5SOc",
  "cta": "vpBr6",
  "adornment_icon": "g5913",
  "remove": "e5lQd",
  "removeButton": "_5-jov",
  "removeButtonIcon": "qCvsb",
  "overlay": "W9Otd",
  "shown": "rHOM1",
  "dark": "a7hiH",
  "spinner": "wO566",
  "spin": "_585e3",
  "grid": "_6aotX"
};
export {
  option_webview_default as default
};
//# sourceMappingURL=option-webview-scss.js.map
